import React, { createContext, FC, useState } from 'react';

export interface IHeaderContext {
  headerHeight: number;
  setHeaderHeight: (val: number) => void;
}

export const HeaderContext = createContext<IHeaderContext>({
  headerHeight: 0,
  setHeaderHeight: () => {},
});

interface IHeaderContextHandlerProps {}

export const HeaderContextHandler: FC<IHeaderContextHandlerProps> = ({ children }): JSX.Element => {
  const [headerHeight, setHeaderHeight] = useState(0);
  return (
    <HeaderContext.Provider value={{ headerHeight, setHeaderHeight }}>
      {children}
    </HeaderContext.Provider>
  );
};
